import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'RtCommonFooterText',
  props: {
    subArea1: { default: '' },
    fallback: { default: '' }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})